module.exports = __webpack_public_path__ + "static/img/6.d46bb8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/screenshots/6.jpg
// module id = Zoti
// module chunks = 0